import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  ElementRef,
  Input,
  NgZone,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { Store } from '@ngxs/store';
import { ComponentsService, Outlet2Service,IscontrolComponent } from '@ic-builder/is-base';
import { MatDialog } from '@angular/material/dialog';

@Component({
  selector: 'isnumber',
  templateUrl: './number.component.html',
  styleUrls: ['./number.component.scss'],
})
export class NumberComponent extends IscontrolComponent implements OnInit {
  @Input() label: string;
  @Input() initialValue: string;
  @Input('frmGrp') frmGrp: FormGroup;

  min: number;
  max: number;
  step = 1.0;
  get fc(): FormControl {
    return this.formControl;
  }

  controlid: number;
  formControl: FormControl;
  translation: any | null = null;

  constructor(
    comp: ComponentsService,
    public outlet: Outlet2Service,
    private compserv: ComponentsService,
    public store: Store,
    public NgZone: NgZone,
    public dialog: MatDialog,
    public el: ElementRef,
    public cd: ChangeDetectorRef
  ) {
    super(comp, store, outlet, NgZone, dialog, el, cd);
  }

  ngOnInit(): void {
    if (this.formInput) {
      this.controlid = super.initControl(
        this.id.toString() + '.number',
        this.initialValue,
        'number'
      );
      this.formControl = super.getFormControl(this.controlid);
    } else {
      //this.formControl = new FormControl(this.initialValue);
    }
  }

  controlnameValueChanges(newVal) {
    this.compserv.formcontrols.get(this.controlid.toString()).name = newVal;
  }

  afterformReady() {
    //this.el.nativeElement.querySelector('input').focus();
    if (this.formControl) {
      if (this['valueChanges']) {
        this.formControl.valueChanges.subscribe((item) => {
          this['valueChanges'](this.formControl.value);
        });
      }
    }
  }

  translate(lang){
    if (this.translation){
      this.label = this.translation[lang];
    }
  }
}
